const keynames = [
    {
        en: 'Caid',
        zh: '申请编号'
    },
    {
        en: 'Daid',
        zh: '申请编号'
    },
    {
        en: 'PartnerNumber',
        zh: '合作伙伴客户号'
    },
    {
        en: 'PartnerName',
        zh: '合作伙伴名称'
    },
    {
        en: 'CreateTime',
        zh: '创建时间'
    }, {
        en: 'PartnerType',
        zh: '使用类别'
    }, {
        en: 'CustomerNumber',
        zh: '客户编号'
    }, {
        en: 'CustomerName',
        zh: '客户名称'
    }, {
        en: 'CreateOrderType',
        zh: '下单类型'
    }, {
        en: 'ContractType',
        zh: '合同类型'
    }, {
        en: 'ProductType',
        zh: '产品类型'
    }, {
        en: 'AgreementNumber',
        zh: '合同号'
    }, {
        en: 'FirstYearAmount',
        zh: '合同首年金额'
    }, {
        en: 'TotalAmount',
        zh: '合同总金额'
    }, {
        en: 'BillingTerm',
        zh: '账期'
    }, {
        en: 'PaymentWay',
        zh: '付款周期'
    }, {
        en: 'Comment',
        zh: '备注'
    }, {
        en: 'GuaranteeTotalAmount',
        zh: '担保总额度'
    }, {
        en: 'PayableAmount',
        zh: '账期内应付金额'
    }, {
        en: 'OverdueAmount',
        zh: '逾期金额'
    }, {
        en: 'FutureHighestAmount',
        zh: '未来四个月最高付款金额'
    }, {
        en: 'AvailableAmount',
        zh: '可用额度'
    }, {
        en: 'CreateUser',
        zh: '申请者'
    }, {
        en: 'IsStandardTerm',
        zh: '是否标准账期'
    }, {
        en: 'EptAttachmentID',
        zh: '附件'
    }, {
        en: 'Status',
        zh: '状态'
    }, {
        en: 'CreditType',
        zh: '申请类型'
    }, {
        en: 'GuaranteeNumber',
        zh: '保函编号'
    }, {
        en: 'ChannelAgreementNumber',
        zh: '渠道协议编号'
    }, {
        en: 'GuaranteeStartDate',
        zh: '保函有效期开始时间'
    }, {
        en: 'GuaranteeEndDate',
        zh: '保函有效期结束时间'
    }, {
        en: 'Website',
        zh: '网址'
    }, {
        en: 'Amount',
        zh: '金额'
    }, {
        en: 'Guarantor',
        zh: '担保方'
    }, {
        en: 'BankAccount',
        zh: '银行账号'
    }, {
        en: 'BankName',
        zh: '开户行'
    }, {
        en: 'ExpressCompany',
        zh: '快递公司'
    }, {
        en: 'ExpressNumber',
        zh: '快递号'
    }, {
        en: 'Deid',
        zh: '申请编号'
    }, {
        en: 'RefDaid',
        zh: '关联的增加保函流水号'
    }, {
        en: 'Deposit',
        zh: '保证金'
    }, {
        en: 'BankGuarantee',
        zh: '银行保函'
    }, {
        en: 'CorpGuarantee',
        zh: '公司保函'
    }, {
        en: '30Days',
        zh: '30天'
    }
    , {
        en: '45Days',
        zh: '45天'
    }
    , {
        en: '60Days',
        zh: '60天'
    }, {
        en: '90Days',
        zh: '90天'
    }, {
        en: 'AdditionalOrder',
        zh: '追加订单'
    }, {
        en: 'InitialOrder',
        zh: '初始订单'
    }, {
        en: 'RecordFileId',
        zh: '附件'
    }, {
        en: 'ChannelAgreementName',
        zh: '渠道协议名称'
    }, {
        en: 'GuaranteeRelationship',
        zh: '担保关系'
    }, {
        en: 'AccountingDate',
        zh: '到帐日期'
    }, {
        en: 'DepositExpiryDate',
        zh: '保证金失效日期'
    }, {
        en: 'ChannelAgreement',
        zh: '银行保函'
    }, {
        en: 'CorpGuarantee',
        zh: '公司保函'
    }
    , {
        en: 'LumpSum',
        zh: 'Lump Sum'
    }, {
        en: 'AnnualAdditional',
        zh: 'Annual'
    }
]

const en2zh = (en: string) => {
    let str = en
    // eslint-disable-next-line array-callback-return
    keynames.map(item => {
        if (item.en === en) {
            str = item.zh
        }
    })
    return str
}

export default en2zh